import { Component, Input, Signal, TemplateRef } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-mobile-emulator-layout',
  templateUrl: './mobile-emulator-layout.component.html',
  styleUrls: ['./mobile-emulator-layout.component.scss'],
  standalone: false,
})
export class MobileEmulatorLayoutComponent {
  public static readonly LOADER_CHANGE_DEBOUNCE_TIME_MS: number = 200;

  @Input() public routerOutlet: TemplateRef<any>;

  public $loading: Signal<boolean>;

  constructor(private loaderService: LoaderService) {
    this.$loading = toSignal(
      this.loaderService.loader.pipe(debounceTime(MobileEmulatorLayoutComponent.LOADER_CHANGE_DEBOUNCE_TIME_MS)),
    );
  }
}
